(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5550],{

/***/ 23070:
/***/ (function(module) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),

/***/ 30432:
/***/ (function(module) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),

/***/ 88393:
/***/ (function(module) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),

/***/ 46236:
/***/ (function(module) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),

/***/ 99733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSlice = __webpack_require__(67456);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),

/***/ 31798:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castSlice = __webpack_require__(99733),
    hasUnicode = __webpack_require__(90800),
    stringToArray = __webpack_require__(27327),
    toString = __webpack_require__(67751);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),

/***/ 12041:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayReduce = __webpack_require__(23070),
    deburr = __webpack_require__(50504),
    words = __webpack_require__(47141);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),

/***/ 84710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(46236);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),

/***/ 90800:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),

/***/ 76693:
/***/ (function(module) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),

/***/ 27327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiToArray = __webpack_require__(30432),
    hasUnicode = __webpack_require__(90800),
    unicodeToArray = __webpack_require__(23306);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),

/***/ 23306:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),

/***/ 10089:
/***/ (function(module) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),

/***/ 38802:
/***/ (function(module) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ 50504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var deburrLetter = __webpack_require__(84710),
    toString = __webpack_require__(67751);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),

/***/ 58371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCompounder = __webpack_require__(12041),
    upperFirst = __webpack_require__(96740);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),

/***/ 59491:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(67751);

/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return toString(value).toLowerCase();
}

module.exports = toLower;


/***/ }),

/***/ 96740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(31798);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),

/***/ 47141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var asciiWords = __webpack_require__(88393),
    hasUnicodeWord = __webpack_require__(76693),
    toString = __webpack_require__(67751),
    unicodeWords = __webpack_require__(10089);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),

/***/ 19330:
/***/ (function(module) {

/* eslint-disable vars-on-top, no-var, prefer-template */
var isRegExp = function (re) { 
  return re instanceof RegExp;
};
var escapeRegExp = function escapeRegExp(string) {
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
};
var isString = function (value) {
  return typeof value === 'string';
};
var flatten = function (array) {
  var newArray = [];

  array.forEach(function (item) {
    if (Array.isArray(item)) {
      newArray = newArray.concat(item);
    } else {
      newArray.push(item);
    }
  });

  return newArray;
};

/**
 * Given a string, replace every substring that is matched by the `match` regex
 * with the result of calling `fn` on matched substring. The result will be an
 * array with all odd indexed elements containing the replacements. The primary
 * use case is similar to using String.prototype.replace except for React.
 *
 * React will happily render an array as children of a react element, which
 * makes this approach very useful for tasks like surrounding certain text
 * within a string with react elements.
 *
 * Example:
 * matchReplace(
 *   'Emphasize all phone numbers like 884-555-4443.',
 *   /([\d|-]+)/g,
 *   (number, i) => <strong key={i}>{number}</strong>
 * );
 * // => ['Emphasize all phone numbers like ', <strong>884-555-4443</strong>, '.'
 *
 * @param {string} str
 * @param {RegExp|str} match Must contain a matching group
 * @param {function} fn
 * @return {array}
 */
function replaceString(str, match, fn) {
  var curCharStart = 0;
  var curCharLen = 0;

  if (str === '') {
    return str;
  } else if (!str || !isString(str)) {
    throw new TypeError('First argument to react-string-replace#replaceString must be a string');
  }

  var re = match;

  if (!isRegExp(re)) {
    re = new RegExp('(' + escapeRegExp(re) + ')', 'gi');
  }

  var result = str.split(re);

  // Apply fn to all odd elements
  for (var i = 1, length = result.length; i < length; i += 2) {
    /** @see {@link https://github.com/iansinnott/react-string-replace/issues/74} */
    if (result[i] === undefined || result[i - 1] === undefined) {
      console.warn('reactStringReplace: Encountered undefined value during string replacement. Your RegExp may not be working the way you expect.');
      continue;
    }

    curCharLen = result[i].length;
    curCharStart += result[i - 1].length;
    result[i] = fn(result[i], i, curCharStart);
    curCharStart += curCharLen;
  }

  return result;
}

module.exports = function reactStringReplace(source, match, fn) {
  if (!Array.isArray(source)) source = [source];

  return flatten(source.map(function(x) {
    return isString(x) ? replaceString(x, match, fn) : x;
  }));
};


/***/ }),

/***/ 89272:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-care/[slug]",
      function () {
        return __webpack_require__(61913);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "jL": function() { return /* binding */ ButtonShape; },
  "qE": function() { return /* binding */ ButtonSize; },
  "Wu": function() { return /* binding */ ButtonVariant; },
  "ZP": function() { return /* binding */ v5_Button; }
});

// UNUSED EXPORTS: getButtonStyle

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/memoizee/index.js
var memoizee = __webpack_require__(37453);
var memoizee_default = /*#__PURE__*/__webpack_require__.n(memoizee);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/utils/noOp.ts
var noOp = __webpack_require__(47597);
;// CONCATENATED MODULE: ./src/utils/shouldAllowReferrer.ts
const patientAppHrefRegex = /(carbonhealth\.com|^)\/patients/;
const shouldAllowReferrer = (url)=>typeof url === "string" ? patientAppHrefRegex.test(url) : false;

// EXTERNAL MODULE: ./src/components/v5/LinkOrButton.tsx
var LinkOrButton = __webpack_require__(73439);
;// CONCATENATED MODULE: ./src/components/v5/Button.tsx






const ButtonVariant = {
    DESTROY: "destroy",
    GHOST: "ghost",
    GREEN: "green",
    OUTLINE: "outline",
    FILL: "fill",
    SELECTED_FILL: "selectedFill",
    NAKED: "naked"
};
const ButtonSize = {
    XS: "xs",
    SM: "sm",
    MD: "md",
    LG: "lg",
    JB: "jb"
};
const ButtonShape = {
    ROUND: "round",
    CIRCLE: "circle"
};
/**
 * Note: 'hover:' and 'disabled:hover:' are required because 'a' tags do not match 'enabled:'
 */ const styles = {
    focus: "outline-hidden outline-4 outline-offset-0 outline-brightBlue focus-visible:outline",
    base: "border border-solid box-border transition-colors transition-opacity flex justify-center items-center",
    baseText: "whitespace-nowrap text-center font-i",
    baseInteraction: "cursor-pointer disabled:cursor-default disabled:opacity-70",
    destroy: "bg-error-800 border-error-800 text-white hover:text-white hover:bg-error-600 hover:border-error-600 disabled:hover:bg-error-800 disabled:hover:border-error-800",
    ghost: "border-gray100 bg-gray800/10 text-gray800 hover:text-gray800 disabled:hover:bg-gray100 hover:bg-gray800/20 hover:border-gray50 disabled:hover:border-gray100",
    green: "border-darkGreen bg-darkGreen text-white hover:text-white hover:bg-green disabled:hover:bg-darkGreen hover:border-green disabled:hover:border-darkGreen",
    outline: "border-gray800 bg-white text-gray800 hover:bg-gray800 hover:text-white disabled:hover:bg-white disabled:hover:text-gray800",
    fill: "border-gray800 bg-gray800 text-white disabled:hover:text-white hover:bg-white hover:text-gray800 disabled:hover:bg-gray800",
    selectedFill: "border-gray800 bg-gray800 text-white cursor-default",
    naked: "bg-transparent border-none",
    xs: "text-base leading-none font-medium px-3.5 py-[7px]",
    sm: "text-base leading-none font-medium px-[18px] py-[13px]",
    md: "text-base leading-none font-bold px-5 py-[17px]",
    lg: "text-base leading-none font-bold px-6 py-[21px]",
    jb: "text-xl leading-none font-bold p-[25px]",
    round: "rounded-4xl",
    circle: "rounded-full p-2 shrink-0 grow-0 leading-none flex items-center justify-center"
};
const CircleSize = {
    xs: "h-8 w-8 text-sm",
    sm: "h-8 w-8 text-sm",
    md: "h-10 w-10 text-lg",
    lg: "h-10 w-10 text-lg",
    jb: "h-10 w-10 text-lg"
};
const getCircleSize = (size, shape)=>shape === ButtonShape.CIRCLE ? CircleSize[size] : styles[size];
const getButtonStyle = memoizee_default()(function() {
    let variant = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ButtonVariant.FILL, size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ButtonSize.MD, shape = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ButtonShape.ROUND, callerStyle = arguments.length > 3 ? arguments[3] : void 0;
    return [
        styles.focus,
        styles.base,
        styles.baseText,
        styles.baseInteraction,
        styles[variant],
        getCircleSize(size, shape),
        styles[shape],
        callerStyle
    ].join(" ");
}, {
    normalizer: JSON.stringify
});
const getRelAttribute = (href, newTab)=>newTab && href ? shouldAllowReferrer(href) ? "noopener" : "noopener noreferrer" : undefined;
const Button = (param)=>/*#__PURE__*/ {
    let { variant =ButtonVariant.FILL , size =ButtonSize.MD , shape =ButtonShape.ROUND , children , onClick , href , newTab , disabled =false , className ="" , ariaLabel , ...props } = param;
    return (0,jsx_runtime.jsx)(LinkOrButton/* default */.Z, {
        href: href,
        target: newTab ? "_blank" : undefined,
        rel: getRelAttribute(href, newTab),
        onClick: disabled ? noOp/* noOp */.E : onClick,
        className: getButtonStyle(variant, size, shape, className),
        disabled: disabled,
        "aria-label": ariaLabel,
        "data-cy": props["data-cy"],
        children: children
    });
};
/* harmony default export */ var v5_Button = (/*#__PURE__*/react.memo(Button));


/***/ }),

/***/ 61913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ get_care_slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(93288);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(32466);
// EXTERNAL MODULE: ./src/_services/api.ts + 2 modules
var api = __webpack_require__(95832);
// EXTERNAL MODULE: ./src/components/_common/_constants.ts + 1 modules
var _constants = __webpack_require__(93932);
// EXTERNAL MODULE: ./src/constants/practiceIds.ts
var practiceIds = __webpack_require__(34557);
// EXTERNAL MODULE: ./src/utils/cms/cms.ts
var cms = __webpack_require__(43367);
// EXTERNAL MODULE: ./src/utils/isReasonDiscoverable.ts + 1 modules
var isReasonDiscoverable = __webpack_require__(79761);
// EXTERNAL MODULE: ./src/utils/redirectToLowercase.ts
var redirectToLowercase = __webpack_require__(56040);
// EXTERNAL MODULE: ./src/components/v5/Region/RegionTreeSelector.tsx + 5 modules
var RegionTreeSelector = __webpack_require__(93994);
// EXTERNAL MODULE: ./src/page-containers/booking/utils/bookingStep.ts
var bookingStep = __webpack_require__(43612);
// EXTERNAL MODULE: ./src/i18n.ts + 5 modules
var src_i18n = __webpack_require__(76361);
// EXTERNAL MODULE: ./src/store/index.ts + 6 modules
var src_store = __webpack_require__(40367);
// EXTERNAL MODULE: ./src/store/slices/userLocation.ts
var userLocation = __webpack_require__(36330);
// EXTERNAL MODULE: ./src/useMediaQuery.ts
var useMediaQuery = __webpack_require__(57974);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(56722);
// EXTERNAL MODULE: ./src/_services/featureFlagConstants.ts
var featureFlagConstants = __webpack_require__(72714);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlags.ts
var useFeatureFlags = __webpack_require__(15343);
// EXTERNAL MODULE: ./src/hooks/useSoonestVirtualSlot.ts
var useSoonestVirtualSlot = __webpack_require__(77230);
// EXTERNAL MODULE: ./src/components/v5/SkipLink.tsx
var SkipLink = __webpack_require__(85527);
;// CONCATENATED MODULE: ./src/page-containers/get-care/components/ListPrefix.tsx




const ListPrefix = /*#__PURE__*/ react.memo(function ListPrefix(param) {
    let { shouldShowResultCount , resultCount , skipTargetId , text  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "df aic jcsb ".concat(shouldShowResultCount ? "" : "h0"),
        children: [
            shouldShowResultCount && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "font-ir fs14",
                children: i18n.t("{{count}} results", {
                    count: resultCount
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "pos-a right0 top0 bottom0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkipLink/* default */.Z, {
                    item: {
                        targetId: skipTargetId || "insurance-and-pricing",
                        text: text || i18n.t("Skip list")
                    },
                    showOnFocus: true
                })
            })
        ]
    });
});
/* harmony default export */ var components_ListPrefix = (ListPrefix);

// EXTERNAL MODULE: ./src/utils/analytics/constants.ts
var constants = __webpack_require__(557);
// EXTERNAL MODULE: ./src/utils/analytics/eventQueue.ts
var eventQueue = __webpack_require__(57659);
// EXTERNAL MODULE: ./src/utils/arrays.ts
var arrays = __webpack_require__(91309);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Collapse/Collapse.js + 87 modules
var Collapse = __webpack_require__(45959);
// EXTERNAL MODULE: ./node_modules/lodash/compact.js
var compact = __webpack_require__(38802);
var compact_default = /*#__PURE__*/__webpack_require__.n(compact);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(21395);
// EXTERNAL MODULE: ./src/page-containers/booking/utils/bookingQuery.ts
var bookingQuery = __webpack_require__(28954);
// EXTERNAL MODULE: ./src/page-containers/get-care/components/ScrollContainer.tsx
var ScrollContainer = __webpack_require__(86498);
// EXTERNAL MODULE: ./src/useS3ImgSrc.tsx
var useS3ImgSrc = __webpack_require__(52221);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(26420);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/hooks/useReadableSlotTime.ts + 1 modules
var useReadableSlotTime = __webpack_require__(8764);
// EXTERNAL MODULE: ./src/components/v5/Glimmer.tsx
var Glimmer = __webpack_require__(88177);
// EXTERNAL MODULE: ./src/components/v5/NextImage.tsx + 1 modules
var NextImage = __webpack_require__(5621);
;// CONCATENATED MODULE: ./src/components/v5/Locations/ImagePair.tsx




const shouldRenderImages = (images)=>Array.isArray(images) && images.length === 2;
const ImagePair = (param)=>// @ts-expect-error TS2322: Type 'false | Element' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
{
    let { images , className ="" , loading  } = param;
    return shouldRenderImages(images) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "dg gafc gg2 ".concat(className),
        children: images.map((param)=>/*#__PURE__*/ {
            let { src , alt  } = param;
            return (0,jsx_runtime.jsx)("span", {
                className: "fx br2",
                children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                    height: "calc(70px + 4vw)"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    className: "br2",
                    src: src,
                    alt: alt,
                    height: 500,
                    width: 700
                })
            }, src);
        })
    });
};
/* harmony default export */ var Locations_ImagePair = (/*#__PURE__*/react.memo(ImagePair));

;// CONCATENATED MODULE: ./src/components/v5/Locations/ClinicListRow.tsx









const Loading = /*#__PURE__*/ react.memo(function Loading(param) {
    let { images  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "dg gg1 gafr w100p pv2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Locations_ImagePair, {
                images: images,
                loading: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                height: 30,
                style: {
                    marginTop: "0.5rem"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                height: 22,
                width: "70%"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                height: 22,
                width: "30%"
            })
        ]
    });
});
const Link = (param)=>{
    let { href , children , ...props } = param;
    const shouldRendorPlainAnchor = typeof href === "string" || !href;
    return shouldRendorPlainAnchor ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: href,
        ...props,
        children: children
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        ...props,
        children: children
    });
};
const ClinicListRow = /*#__PURE__*/ react.forwardRef(function _ClinicListRow(param, ref) {
    let { location , href , onClick , soonestSlotTime , clampLocName , left , loading , images  } = param;
    const [hovered, setHovered] = (0,react.useState)(false);
    const { name , dist , address: { firstLine  }  } = location;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { GROWTH_DISCOVERY_APPT_REASON_PAGE_AVAILABILITY_ENABLED  } = (0,src_store/* useTypedSelector */.ix)((state)=>state.featureFlags);
    const readableSlotTime = (0,useReadableSlotTime/* useReadableSlotTime */.H5)(soonestSlotTime);
    const disabled = !soonestSlotTime;
    const isNextLink = typeof href !== "string" && (href === null || href === void 0 ? void 0 : href.pathname);
    return loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "p6 p4-sm",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {
            images: images
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        ref: ref,
        className: "minh18",
        "data-cy": "get-care-location-link",
        style: {
            opacity: disabled ? 0.6 : 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
            href: href,
            ...!_constants/* isCI */.yg && !isNextLink && {
                target: "_blank",
                rel: "noopener noreferrer"
            },
            className: "df fdc p6 p4-sm br5 br0-xs t-100 ".concat(disabled ? "cd" : "hover-bg-gray100"),
            onClick: onClick,
            onMouseEnter: ()=>!disabled && setHovered(true),
            onMouseLeave: ()=>setHovered(false),
            "aria-disabled": disabled,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Locations_ImagePair, {
                    images: images,
                    className: shouldRenderImages(images) ? "pb3" : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "df jcsb",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "df aic",
                            children: [
                                left,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "df fdc oh tofe gray600 font-im fs14",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "fs22 fs18-lg gray800 font-csb pb1 oh tofe ".concat(clampLocName ? "lc1-lg wsnw-lg lcn-sm wsn-sm" : ""),
                                            children: name
                                        }),
                                        Boolean(firstLine || dist) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "df aic fw pb3 t-100 ".concat(hovered ? "gray800" : ""),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "wsnw",
                                                    children: firstLine
                                                }),
                                                dist > -1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "mh1",
                                                    "aria-hidden": true,
                                                    children: "\xb7"
                                                }),
                                                dist > -1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "wsnw",
                                                    children: i18n.t("{{number}} mi", {
                                                        number: dist
                                                    })
                                                })
                                            ]
                                        }),
                                        GROWTH_DISCOVERY_APPT_REASON_PAGE_AVAILABILITY_ENABLED && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            className: "font-ib wsnw fsn pb1 t-100 ".concat(!soonestSlotTime ? "gray600" : hovered ? "darkerGreen" : "darkGreen"),
                                            children: soonestSlotTime ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "visually-hidden",
                                                        children: i18n.t("Soonest appointment:")
                                                    }),
                                                    i18n.t("Next:"),
                                                    " ",
                                                    readableSlotTime
                                                ]
                                            }) : i18n.t("No availability")
                                        })
                                    ]
                                })
                            ]
                        }),
                        soonestSlotTime && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "df fdc aife jcc pl1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "cIcon-arrRight fs24 fs20-sm gray400 t-100 ".concat(hovered ? "gray600" : ""),
                                "aria-hidden": true
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "visually-hidden",
                    children: i18n.t("(opens in new tab)")
                })
            ]
        })
    });
});
/* harmony default export */ var Locations_ClinicListRow = (ClinicListRow);

// EXTERNAL MODULE: ./src/components/v5/Locations/events.ts
var events = __webpack_require__(5816);
// EXTERNAL MODULE: ./src/utils/getRedirectUrl.ts
var getRedirectUrl = __webpack_require__(34488);
// EXTERNAL MODULE: ./src/utils/stateUtils.ts + 1 modules
var stateUtils = __webpack_require__(83202);
;// CONCATENATED MODULE: ./src/components/v5/Locations/VirtualRow.tsx












const VirtualRow_Loading = /*#__PURE__*/ react.memo(function Loading() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "df pv2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                height: 50,
                width: 50,
                style: {
                    borderRadius: "50%",
                    flexShrink: 0
                },
                offset: Glimmer/* GlimmerOffset.XXS */.u.XXS
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dg gg1 gafr w100p ml2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                        height: 30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Glimmer/* default */.Z, {
                        height: 22,
                        width: "30%"
                    })
                ]
            })
        ]
    });
});
const VirtualRow = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { apptReason , hideImages , soonestVirtualSlotQuery , rank , viewId  } = param;
    var _soonestVirtualSlotQuery_data;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const selectedRegion = (0,src_store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const flowId = (0,react.useMemo)(v4/* default */.Z, []);
    const specialtyId = (0,react.useMemo)(()=>(0,useSoonestVirtualSlot/* getVirtualSpecialtyIds */.wH)(apptReason), [
        apptReason.id
    ]);
    const preselectedState = (0,react.useMemo)(()=>(0,stateUtils/* getStateCodeFromRegionSlug */.GZ)(selectedRegion), [
        selectedRegion
    ]);
    const rowTitle = i18n.t("Book a Virtual Visit");
    const slot = soonestVirtualSlotQuery === null || soonestVirtualSlotQuery === void 0 ? void 0 : soonestVirtualSlotQuery.data;
    const onClick = (0,react.useCallback)(()=>{
        var _soonestVirtualSlotQuery_data;
        const soonestSlotTime = (_soonestVirtualSlotQuery_data = soonestVirtualSlotQuery.data) === null || _soonestVirtualSlotQuery_data === void 0 ? void 0 : _soonestVirtualSlotQuery_data.time;
        if (soonestSlotTime) {
            (0,events/* sendClinicListRowClickEvent */.E)(rowTitle, viewId, undefined, rank, soonestSlotTime, undefined, flowId);
        }
    }, [
        flowId,
        rank,
        rowTitle,
        (_soonestVirtualSlotQuery_data = soonestVirtualSlotQuery.data) === null || _soonestVirtualSlotQuery_data === void 0 ? void 0 : _soonestVirtualSlotQuery_data.time,
        viewId
    ]);
    const virtualImages = hideImages ? [] : [
        {
            src: "/person-on-phone",
            alt: i18n.t("A happy woman sitting on a sofa with her cell phone")
        },
        {
            src: "/dad-with-daughter",
            alt: i18n.t("A happy father with his daughter during a virtual appointment")
        }
    ];
    if (!soonestVirtualSlotQuery.isSettled) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "p6 p4-sm",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualRow_Loading, {})
    });
    // @ts-expect-error TS2322: Type 'null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>>'.
    if (!slot) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Locations_ClinicListRow, {
        images: virtualImages,
        href: (0,getRedirectUrl/* getSchedulingRedirectUrl */._W)({
            flowId,
            apptReasonId: apptReason.id,
            virtual: true,
            specialtyId,
            // @ts-expect-error TS2322: Type 'string | null' is not assignable to type 'string | undefined'.
            preselectedState
        }),
        onClick: onClick,
        location: {
            name: rowTitle,
            // @ts-expect-error TS2740: Type '{}' is missing the following properties from type 'Address': firstLine, city, state, zip, and 4 more.
            address: {}
        },
        soonestSlotTime: slot.time,
        left: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "bg-darkMint br50 h12 w12 df aic jcc mr3",
            style: {
                flexShrink: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "cIcon-phone-video fs26 gray800 darkerGreen",
                "aria-hidden": true
            })
        })
    });
});
VirtualRow.displayName = "VirtualRow";
/* harmony default export */ var Locations_VirtualRow = (VirtualRow);

;// CONCATENATED MODULE: ./src/components/v5/Locations/List.tsx












const getLocationImages = (location)=>{
    // @ts-expect-error TS2532: Object is possibly 'undefined'.
    return (location === null || location === void 0 ? void 0 : location.images.slice(0, 2).map((img)=>({
            src: (0,useS3ImgSrc/* s3ImageSource */.Lv)(img.imageId),
            alt: null
        }))) || [];
};
const LocationList = (param)=>{
    let { isSm , loading , apptReason , locations , firstLocRef , soonestVirtualSlotQuery , viewId  } = param;
    const { t  } = (0,src_i18n/* useTranslation */.$G)();
    const router = (0,next_router.useRouter)();
    const isVirtualOnly = locations.length === 0 && !loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScrollContainer/* default */.Z, {
        maxHeight: "calc(82vh - 5vw)",
        disabled: isSm,
        containerTag: "ul",
        children: [
            locations.map((param, i)=>{
                let { location , soonestSlot , specialtyId  } = param;
                const isFirstLoc = i === 0;
                const images = isFirstLoc ? getLocationImages(location) : [];
                const value = t("Book");
                const onClick = async ()=>{
                    if (soonestSlot) {
                        const { bookingLink , flowId , WEB_SCHEDULING_ENABLED  } = await (0,bookingQuery/* getSchedulingLink */.pq)({
                            pathname: router.pathname,
                            specialtyIds: compact_default()([
                                specialtyId
                            ]),
                            webSchedulingQuery: {
                                locationSlug: location.slug,
                                appointmentReasonSlug: apptReason.slug,
                                initialCalendarTime: soonestSlot === null || soonestSlot === void 0 ? void 0 : soonestSlot.time
                            },
                            patientAppSchedulingQuery: {
                                practiceId: location.practiceId,
                                locationId: location.id,
                                apptReasonId: apptReason.id,
                                specialtyId
                            }
                        });
                        (0,events/* sendClinicListRowClickEvent */.E)(value, viewId, location.id, i + 1, soonestSlot === null || soonestSlot === void 0 ? void 0 : soonestSlot.time, location.dist, flowId || undefined);
                        if (WEB_SCHEDULING_ENABLED) {
                            (0,events/* sendInitiateWebSchedulingEvent */.q)(flowId);
                        }
                        router.push(bookingLink);
                    }
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                    in: true,
                    appear: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Locations_ClinicListRow, {
                        // @ts-expect-error TS2322: Type '{ src: string; alt: null; }[]' is not assignable to type '{ src: string; alt?: string | undefined; }[]'.
                        images: images,
                        loading: loading,
                        ref: isFirstLoc ? firstLocRef : null,
                        location: location,
                        soonestSlotTime: soonestSlot === null || soonestSlot === void 0 ? void 0 : soonestSlot.time,
                        clampLocName: true,
                        onClick: onClick
                    }, location.id)
                }, location.id);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Locations_VirtualRow, {
                soonestVirtualSlotQuery: soonestVirtualSlotQuery,
                hideImages: !isVirtualOnly,
                apptReason: apptReason,
                rank: locations.length,
                viewId: viewId
            })
        ]
    });
};
/* harmony default export */ var List = (/*#__PURE__*/react.memo(LocationList));

// EXTERNAL MODULE: ./src/components/v5/Locations/useClinicListBoundaryController.ts + 1 modules
var useClinicListBoundaryController = __webpack_require__(76096);
// EXTERNAL MODULE: ./src/components/v5/Locations/usePairLocsWithSlots.ts
var usePairLocsWithSlots = __webpack_require__(61802);
;// CONCATENATED MODULE: ./src/components/v5/Locations/ClinicList2.tsx



















const sendClinicOptionsViewedEvent = (viewId, apptReasonId, selectedRegion, options)=>{
    (0,eventQueue/* queueEvent */.x$)({
        typeId: constants/* EventType.ClinicOptionsViewed */.tw.ClinicOptionsViewed,
        extraData: {
            viewId,
            category: constants/* CustomCategory.AppointmentScheduling */.mg.AppointmentScheduling,
            bookingStep: bookingStep/* BookingStep.LOCATION_SELECTION */.a.LOCATION_SELECTION,
            apptDetails: {
                apptReasonId
            },
            selectedRegion,
            options
        }
    });
};
const ClinicList = /*#__PURE__*/ react.memo((param)=>{
    let { locations , apptReason  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const [viewId, setViewId] = (0,react.useState)();
    const locationsSorted = (0,src_store/* useTypedSelector */.ix)((state)=>state.config.locationsSorted);
    const selectedRegion = (0,src_store/* useTypedSelector */.ix)(userLocation/* selectSelectedRegion */.dz);
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const locsInRegion = (0,react.useMemo)(()=>locations.filter((l)=>l.region.slug === selectedRegion), [
        locations,
        selectedRegion
    ]);
    const GROWTH_DISCOVERY_APPT_REASON_PAGE_AVAILABILITY_ENABLED = (0,useFeatureFlags/* useFeatureFlag */.y)(featureFlagConstants/* FeatureFlag.GROWTH_DISCOVERY_APPT_REASON_PAGE_AVAILABILITY_ENABLED */.T.GROWTH_DISCOVERY_APPT_REASON_PAGE_AVAILABILITY_ENABLED);
    const locSlotsQuery = (0,usePairLocsWithSlots/* usePairLocsWithSlotsQuery */.DS)({
        locations: locsInRegion,
        apptReason,
        skip: !locationsSorted || !GROWTH_DISCOVERY_APPT_REASON_PAGE_AVAILABILITY_ENABLED
    });
    const { data: locsToRender  } = locSlotsQuery;
    const reasonsVirtualSpecialtyIds = (0,react.useMemo)(()=>(0,useSoonestVirtualSlot/* getVirtualSpecialtyIds */.wH)(apptReason), [
        apptReason
    ]);
    const soonestVirtualSlotQuery = (0,useSoonestVirtualSlot/* useSoonestVirtualSlotInState */.cO)(reasonsVirtualSpecialtyIds);
    const { ListController , bindList , stop  } = (0,useClinicListBoundaryController/* useListBoundaryController */.m)(locsToRender.length, isSm ? Math.min(4, locsToRender.length) : locsToRender.length);
    const firstLocRef = (0,react.useRef)(null);
    const onListReset = ()=>{
        if (firstLocRef.current) {
            firstLocRef.current.scrollIntoView({
                block: "center",
                behavior: "smooth"
            });
        }
    };
    (0,react.useEffect)(()=>{
        var _locSlotsQuery_data;
        /**
     * On one render after the locsSlotsQuery settles, the list is not yet bound.
     * This means that the bound list length is 0, but the data is actually longer.
     * This check ensures that we don't fire the viewed event if the bound list stops
     * at 0, but the data is longer.
     */ const listNotYetBound = stop === 0 && ((_locSlotsQuery_data = locSlotsQuery.data) === null || _locSlotsQuery_data === void 0 ? void 0 : _locSlotsQuery_data.length) > 0;
        if (locSlotsQuery.isSettled && soonestVirtualSlotQuery.isSettled && !listNotYetBound) {
            var _soonestVirtualSlotQuery_data, _soonestVirtualSlotQuery_data1;
            const clinicOptions = bindList(locSlotsQuery.data).map((param, i)=>{
                let { location , soonestSlot , specialtyId  } = param;
                return {
                    locationId: location.id,
                    milesAway: location.dist || null,
                    rank: i + 1,
                    soonestSlotTime: (soonestSlot === null || soonestSlot === void 0 ? void 0 : soonestSlot.time) || null,
                    specialtyId: specialtyId || null
                };
            });
            const virtualOption = soonestVirtualSlotQuery.data ? {
                locationId: null,
                milesAway: null,
                rank: clinicOptions.length + 1,
                soonestSlotTime: ((_soonestVirtualSlotQuery_data = soonestVirtualSlotQuery.data) === null || _soonestVirtualSlotQuery_data === void 0 ? void 0 : _soonestVirtualSlotQuery_data.time) || null,
                specialtyId: ((_soonestVirtualSlotQuery_data1 = soonestVirtualSlotQuery.data) === null || _soonestVirtualSlotQuery_data1 === void 0 ? void 0 : _soonestVirtualSlotQuery_data1.specialtyIds[0]) || null
            } : null;
            const newViewId = (0,v4/* default */.Z)();
            sendClinicOptionsViewedEvent(newViewId, apptReason.id, selectedRegion, (0,arrays/* compact */.o)([
                ...clinicOptions,
                virtualOption
            ]));
            setViewId(newViewId);
        }
    // Do not add selected region. Only refire this event when data changes and query is settled.
    }, [
        apptReason.id,
        soonestVirtualSlotQuery,
        locSlotsQuery,
        bindList,
        stop
    ]);
    const shouldShowResultCount = !isSm && locsToRender.length > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "ph2 ph0-sm pt6-sm",
        "aria-labelledby": "book-appointment-h2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                id: "book-appointment-h2",
                className: "fs32 fs24-md ls-25 wsnw ph6 ph4-sm",
                children: i18n.t("Book an appointment")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "df aic jcsb pos-r pl6 pr12 ph4-sm",
                style: {
                    marginLeft: "-.6rem"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RegionTreeSelector/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ListPrefix, {
                        text: i18n.t("Skip Carousel"),
                        skipTargetId: "clinic-list-rows",
                        resultCount: locsToRender.length,
                        shouldShowResultCount: shouldShowResultCount
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                loading: !locSlotsQuery.isSettled,
                apptReason: apptReason,
                locations: bindList(locSlotsQuery.data),
                firstLocRef: firstLocRef,
                isSm: isSm,
                // @ts-expect-error TS2322: Type 'QueryState<ApptSlot | null>' is not assignable to type 'QueryState<ApptSlot>'.
                soonestVirtualSlotQuery: soonestVirtualSlotQuery,
                viewId: viewId
            }),
            isSm && locsToRender.length > 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "ph6 ph4-sm",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListController, {
                    onReset: onListReset
                })
            })
        ]
    });
});
ClinicList.displayName = "ClinicList";
/* harmony default export */ var ClinicList2 = (ClinicList);

// EXTERNAL MODULE: ./src/components/v5/Reason/Insurances.tsx
var Insurances = __webpack_require__(3250);
// EXTERNAL MODULE: ./src/components/v5/Button.tsx + 1 modules
var Button = __webpack_require__(6987);
// EXTERNAL MODULE: ./src/components/v5/Footer/SectionHeader.tsx
var SectionHeader = __webpack_require__(56290);
// EXTERNAL MODULE: ./src/components/v5/Footer/SectionLink.tsx
var SectionLink = __webpack_require__(30796);
;// CONCATENATED MODULE: ./src/page-containers/get-care/components/RelatedLinks.tsx








const RelatedLinks = (param)=>{
    let { condition , relatedTo  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "max-w-7xl mx-auto px-8 mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: i18n.t("Similar reasons to {{condition}}", {
                    condition
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row flex-wrap justify-between mt-6 gap-y-6",
                children: [
                    (relatedTo === null || relatedTo === void 0 ? void 0 : relatedTo.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedReasonsSection, {
                        relatedTo: relatedTo
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreServicesSection, {})
                ]
            })
        ]
    });
};
const RelatedReasonsSection = (param)=>{
    let { relatedTo  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const xsButtons = (0,useMediaQuery/* default */.Z)("sm");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "min-w-[24.25rem] w-1/2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* default */.Z, {
                text: i18n.t("SIMILAR REASONS")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-row flex-wrap gap-x-2 gap-y-3 mt-3",
                children: relatedTo.map((relation)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                            size: xsButtons ? Button/* ButtonSize.XS */.qE.XS : Button/* ButtonSize.SM */.qE.SM,
                            variant: Button/* ButtonVariant.GHOST */.Wu.GHOST,
                            href: relation.slug,
                            children: relation.name
                        })
                    }, relation.name))
            })
        ]
    });
};
const MoreServicesSection = ()=>{
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionHeader/* default */.Z, {
                text: i18n.t("MORE SERVICES")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "grid grid-cols-[11.25rem_10rem] gap-y-6 gap-x-12 mt-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("Urgent Care"),
                        href: _constants/* v5Pages.urgentCare */.Td.urgentCare
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("Labs & Lab Results"),
                        href: _constants/* v5Pages.labsAndLabResults */.Td.labsAndLabResults
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("Primary Care"),
                        href: _constants/* v5Pages.primaryCare */.Td.primaryCare
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("Pediatrics"),
                        href: _constants/* v5Pages.pediatrics */.Td.pediatrics
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("Mental Health"),
                        href: _constants/* v5Pages.mentalHealth */.Td.mentalHealth
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("COVID Vaccination"),
                        href: _constants/* v5Pages.covid19Vaccination */.Td.covid19Vaccination
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("Workplace Health"),
                        href: _constants/* v5Pages.workplaceHealth */.Td.workplaceHealth
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("COVID Testing"),
                        href: _constants/* v5Pages.covid19TestingCare */.Td.covid19TestingCare
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("Imaging"),
                        href: _constants/* v5Pages.imaging */.Td.imaging
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionLink/* SectionLink */.I, {
                        text: i18n.t("COVID Positive Care"),
                        href: _constants/* v5Pages.covidTreatment */.Td.covidTreatment
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/_services/featureFlags.ts
var featureFlags = __webpack_require__(30660);
// EXTERNAL MODULE: ./src/components/v5/Layout.tsx + 29 modules
var Layout = __webpack_require__(32122);
;// CONCATENATED MODULE: ./opengraph/components/OgImage.tsx



const IMAGE_DIMENSIONS = {
    width: 1200,
    height: 630
};
const fontPaths = [
    "campton-book",
    "campton-medium",
    "campton-light",
    "campton-semibold",
    "campton-bold",
    "monosten-regular",
    "monosten-light"
];
const OgImage = (param)=>/*#__PURE__*/ {
    let { children , root ="https://carbonhealth.com"  } = param;
    return (0,jsx_runtime.jsxs)("html", {
        lang: "en",
        style: IMAGE_DIMENSIONS,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("head", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        href: _constants/* icomoonUrl */.Mq
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        href: "".concat(root, "/static/css/site.css")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "stylesheet",
                        href: "".concat(root, "/static/css/tailwind.css")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&display=swap",
                        rel: "stylesheet"
                    }),
                    fontPaths.map((f)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            href: "".concat(root, "/static/fonts/").concat(f, ".woff2"),
                            rel: "stylesheet",
                            type: "font/woff2"
                        }, f))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("body", {
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/constants/Reason/getCareDiscoveryColorScheme.ts + 1 modules
var getCareDiscoveryColorScheme = __webpack_require__(54043);
;// CONCATENATED MODULE: ./src/page-containers/get-care/ogimage.tsx




const propsValidator = (props)=>// @ts-expect-error TS2322: Type 'unknown' is not assignable to type 'boolean'.
    props && typeof props === "object" && typeof props.title === "string" && typeof props.id === "string";
const GetCareSlugOg = (param)=>{
    let { id , title , root ="https://carbonhealth.com"  } = param;
    const colorScheme = (0,getCareDiscoveryColorScheme/* getCareDiscoveryColorScheme */.m)(id, title);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OgImage, {
        root: root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "df h100p w100p",
            style: {
                backgroundColor: colorScheme.backgroundColor
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "fx4 df fdc jcsb pb24 pt18 ph18",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(root, "/static/img/v5/logo-black.svg"),
                            alt: "",
                            width: 300
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "dg gafr gg6",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    className: "fs26 font-mb ttu",
                                    style: {
                                        color: colorScheme.color
                                    },
                                    children: "Book an Appointment"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "font-csb fs60",
                                    children: title
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "fx3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        height: "100%",
                        src: "".concat(root, "/static/img/v5/patterns/full/").concat(colorScheme.patternSrc, ".png"),
                        alt: ""
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ogimage = (GetCareSlugOg);

;// CONCATENATED MODULE: ./src/page-containers/index/defaultOg.tsx



const defaultOg_propsValidator = ()=>true;
const DefaultOg = (param)=>/*#__PURE__*/ {
    let { root ="https://carbonhealth.com"  } = param;
    return (0,jsx_runtime.jsx)(OgImage, {
        root: root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "df h100p w100p aic jcc bg-darkerMint",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "ph20 pb40 pt18 df fdc aic jcc",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "mb20",
                        src: "".concat(root, "/static/img/v5/logo-white.svg"),
                        alt: "",
                        width: 300
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "font-csb maxw50 white fs60 tac pos-r",
                        children: [
                            "Making",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "pos-r",
                                children: [
                                    "good health",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "pos-a right0 left0 ma",
                                        width: "280px",
                                        height: "18px",
                                        style: {
                                            bottom: -2,
                                            opacity: 0.6,
                                            filter: "grayscale(30%) hue-rotate(-20deg)",
                                            transform: "rotate(-0.5deg)"
                                        },
                                        src: "".concat(root, "/static/img/v5/home/word-yellow-underline.jpg"),
                                        alt: ""
                                    })
                                ]
                            }),
                            " ",
                            "accessible to everyone",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "pos-a",
                                width: "100px",
                                style: {
                                    bottom: -50,
                                    right: 70,
                                    opacity: 0.6,
                                    transform: "rotate(230deg)",
                                    filter: "brightness(140%) saturate(200%)"
                                },
                                src: "".concat(root, "/static/img/v5/illustrated-arrow-purple.jpg"),
                                alt: ""
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var defaultOg = (DefaultOg);

// EXTERNAL MODULE: ./src/utils/urls.ts
var urls = __webpack_require__(4121);
;// CONCATENATED MODULE: ./opengraph/utils/ogPathMap.ts




const OgPathMap = {
    [_constants/* v5Pages.getCareSlug */.Td.getCareSlug]: {
        Component: ogimage,
        propsValidator: propsValidator
    },
    [_constants/* v5Pages.home */.Td.home]: {
        Component: defaultOg,
        propsValidator: defaultOg_propsValidator
    }
};
const isDefinedOgPath = (path)=>typeof path === "string" && path in OgPathMap;
const isValidPathAndProps = (path, props)=>isDefinedOgPath(path) && OgPathMap[path].propsValidator(props);
const getOgImagePath = (path, props, host)=>{
    const base = (0,urls/* getRootUrlFromCarbonHost */.LJ)(host);
    const route = "/api/og";
    const query = new URLSearchParams({
        path: encodeURIComponent(path),
        props: encodeURIComponent(JSON.stringify(props))
    });
    return "".concat(base).concat(route, "?").concat(query);
};

// EXTERNAL MODULE: ./src/components/v5/Faq/Faq.tsx + 1 modules
var Faq = __webpack_require__(73349);
// EXTERNAL MODULE: ./src/components/v5/Nav/useNavState.ts
var useNavState = __webpack_require__(13284);
// EXTERNAL MODULE: ./src/utils/markdown.tsx
var markdown = __webpack_require__(5380);
// EXTERNAL MODULE: ./src/components/animations/Fade.tsx
var Fade = __webpack_require__(25);
// EXTERNAL MODULE: ./src/components/v5/Faq/QuestionAnswer.tsx + 1 modules
var QuestionAnswer = __webpack_require__(6182);
// EXTERNAL MODULE: ./src/components/v5/Reason/ShowMoreButton.tsx
var ShowMoreButton = __webpack_require__(41519);
;// CONCATENATED MODULE: ./src/components/v5/Reason/ApptReasonFaq.tsx









const ApptReasonFaq = (param)=>{
    let { title , description , faq , isInsuranceAccepted  } = param;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const [isExpanded, setIsExpanded] = (0,react.useState)(false);
    // For whatever reason, the markdown() library returns different things during client and server
    // rendering. On react v18 in strict mode, this causes a
    // https://nextjs.org/docs/messages/react-hydration-error.
    //
    // React then throws an "Uncaught Error: There was an error while hydrating. Because the error
    // happened outside of a Suspense boundary, the entire root will switch to client rendering."
    //
    // This useEffect() block defers rendering the markdown until the second render,
    // which resolves the error and gets _most_ of the page loading faster.
    const [desc, setDesc] = (0,react.useState)(description);
    (0,react.useEffect)(()=>{
        if (typeof description === "string") {
            setDesc((0,markdown/* markdown */.J)(description));
        }
    }, [
        description,
        setDesc
    ]);
    (0,react.useEffect)(()=>{
        setIsExpanded(!isSm);
    }, [
        isSm
    ]);
    const shouldRenderShowMoreButton = isSm && faq && faq.length > 1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "appt-reason-faq",
        className: shouldRenderShowMoreButton ? "" : "pb8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "fs24-sm ls-25 pb2",
                children: title
            }),
            !isInsuranceAccepted && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                className: "font-cm fs28 fs20-md fs16-sm gray800 lh22 lh15-md",
                children: i18n.t("Prices vary, insurance not accepted")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "font-cm fw5 font-i-sm fw5-sm fs28 fs20-md fs16-sm ls-3 lh12 lh15-sm m-0 ",
                children: desc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                className: "md:mt-5 -mt-2",
                children: [
                    faq === null || faq === void 0 ? void 0 : faq.map((qa, i)=>{
                        const isFirstFaq = i === 0;
                        const isLastFaq = i === faq.length - 1;
                        const hideBorder = isFirstFaq && isSm && !isExpanded || isLastFaq;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                            in: isFirstFaq || isExpanded,
                            unmountOnExit: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                in: i === 0 || isExpanded,
                                appear: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionAnswer/* default */.Z, {
                                    ...qa,
                                    isPreview: !isExpanded && isSm && isFirstFaq,
                                    hideIcon: !isExpanded && isSm && isFirstFaq,
                                    hideBorder: hideBorder,
                                    isExpandedOverride: isFirstFaq && isSm,
                                    // @ts-expect-error TS2322: Type '(() => void) | null' is not assignable to type '(() => void) | undefined'.
                                    onClick: !isExpanded && isSm && isFirstFaq ? ()=>{
                                        setIsExpanded(!isExpanded);
                                    } : null
                                })
                            })
                        }, qa.q + i);
                    }),
                    shouldRenderShowMoreButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMoreButton/* default */.Z, {
                        style: {
                            marginTop: "1rem"
                        },
                        text: isExpanded ? i18n.t("Show Less") : i18n.t("Show More"),
                        onClick: ()=>{
                            setIsExpanded(!isExpanded);
                        },
                        flipIcon: isExpanded
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Reason_ApptReasonFaq = (ApptReasonFaq);

// EXTERNAL MODULE: ./src/constants/InsurancePricingConstants.tsx
var InsurancePricingConstants = __webpack_require__(50815);
// EXTERNAL MODULE: ./src/utils/cms/types.ts
var types = __webpack_require__(59081);
// EXTERNAL MODULE: ./src/utils/fetchLocationsByReasonId.ts
var fetchLocationsByReasonId = __webpack_require__(97142);
// EXTERNAL MODULE: ./src/utils/titleCase.ts
var titleCase = __webpack_require__(32940);
// EXTERNAL MODULE: ./node_modules/@c10h/colors/es/palette.js
var palette = __webpack_require__(45602);
// EXTERNAL MODULE: ./src/page-containers/get-care/stylesheets/grid.module.scss
var grid_module = __webpack_require__(4080);
var grid_module_default = /*#__PURE__*/__webpack_require__.n(grid_module);
;// CONCATENATED MODULE: ./src/page-containers/get-care/components/Comp.tsx






const PageContainer = (param)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: "df fdc aic  ".concat(className),
        ...props
    });
};
// eslint-disable-next-line react/display-name
const InnerContainer = /*#__PURE__*/ react.forwardRef((param, ref)=>/*#__PURE__*/ {
    let { className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        ref: ref,
        className: "ph8 ph4-sm maxw42 w100p ".concat(className),
        ...props
    });
});
const Comp_Faq = (param)=>/*#__PURE__*/ {
    let { backgroundColor , patternSrc , children  } = param;
    return (0,jsx_runtime.jsxs)(PageContainer, {
        className: "pb20 pb0-sm",
        style: {
            gridArea: "faq1",
            backgroundColor
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "minh20 minh16-lg w100p dn-sm pos-r mt20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    layout: "fill",
                    src: "/patterns/".concat(patternSrc),
                    alt: "",
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContainer, {
                className: "mt16 mt20-sm",
                children: children
            })
        ]
    });
};
const stickyStyles = {
    position: "sticky",
    top: "9rem"
};
const emptyStyles = {};
const Action = (param)=>/*#__PURE__*/ {
    let { isSticky , children , hideGutters  } = param;
    return (0,jsx_runtime.jsx)(PageContainer, {
        className: "bg-gray50 pb1",
        style: {
            gridArea: "book"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContainer, {
            className: "h100p pv4 ".concat(hideGutters ? "ph0-f" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: isSticky ? stickyStyles : emptyStyles,
                children: children
            })
        })
    });
};
const Comp_Insurances = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsxs)(PageContainer, {
        style: {
            gridArea: "ins",
            backgroundColor: getCareDiscoveryColorScheme/* testColors.darkBlue */.k.darkBlue
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContainer, {
                className: "pt20 pb10 pt10-sm",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "minh20 minh10-sm w100p bgpc",
                style: {
                    backgroundImage: "url(/static/img/v5/patterns/splatter.webp)"
                }
            })
        ]
    });
};
const GlobalFaq = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(PageContainer, {
        style: {
            gridArea: "faq2"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerContainer, {
            children: children
        })
    });
};
const Grid = (param)=>/*#__PURE__*/ {
    let { children  } = param;
    return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((grid_module_default()).grid, " dg jcc"),
            style: {
                borderBottom: "1px solid ".concat(palette.gray100)
            },
            children: children
        })
    });
};
const Wrapper = {
    Faq: Comp_Faq,
    Action,
    Insurances: Comp_Insurances,
    GlobalFaq,
    Grid
};

;// CONCATENATED MODULE: ./src/page-containers/get-care/reason.tsx





















const Reason = (param)=>{
    let { content , reason , apptReasonLocationIds  } = param;
    var _content_meta, _content_meta1, _content_faqs;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { locations , host , locationsSorted  } = (0,src_store/* useTypedSelector */.ix)((state)=>state.config);
    const locationsMatchingApptReason = (0,react.useMemo)(()=>locations.filter((l)=>apptReasonLocationIds.includes(l.id)), [
        reason.id,
        locationsSorted
    ]);
    const { backgroundColor , patternSrc  } = (0,getCareDiscoveryColorScheme/* getCareDiscoveryColorScheme */.m)(reason.id, content.name);
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const generalFaqs = (0,react.useMemo)(()=>{
        var _content_shared_faqs;
        return ((_content_shared_faqs = content.shared_faqs) === null || _content_shared_faqs === void 0 ? void 0 : _content_shared_faqs.reduce((acc, next)=>next.faqs ? [
                ...acc,
                ...next.faqs.map((qa)=>({
                        q: qa.question,
                        a: qa.answer
                    }))
            ] : acc, [])) || [];
    }, [
        content.id
    ]);
    const pageTitle = ((_content_meta = content.meta) === null || _content_meta === void 0 ? void 0 : _content_meta.title) || "".concat((0,titleCase/* toTitleCase */.L)(content.name), " | Carbon Health");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: pageTitle,
        pageDescription: ((_content_meta1 = content.meta) === null || _content_meta1 === void 0 ? void 0 : _content_meta1.description) || content.description,
        navTheme: isSm ? useNavState/* NavTheme.BLACK */.Xm.BLACK : useNavState/* NavTheme.DEFAULT */.Xm.DEFAULT,
        navStartTransparent: isSm,
        wrapClasses: "ovf-unset" // required for position sticky to work
        ,
        absolutePageImage: getOgImagePath("/get-care/[slug]", {
            id: reason.id,
            title: content.name
        }, host),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper.Grid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper.Faq, {
                        backgroundColor: backgroundColor,
                        patternSrc: patternSrc,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reason_ApptReasonFaq, {
                            title: content.name,
                            description: content.description,
                            faq: ((_content_faqs = content.faqs) === null || _content_faqs === void 0 ? void 0 : _content_faqs.map((qa)=>({
                                    q: qa.question,
                                    a: qa.answer
                                }))) || [],
                            isInsuranceAccepted: content.insurance_type !== types/* CareInsuranceType.NoInsurance */.o.NoInsurance
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper.Action, {
                        isSticky: !isSm,
                        hideGutters: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ClinicList2, {
                            locations: locationsMatchingApptReason,
                            apptReason: reason
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper.Insurances, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Insurances/* default */.ZP, {
                            headerText: (0,Insurances/* getCareInsuranceText */.E6)(i18n.t.bind(i18n), content.insurance_type, content.name),
                            insuranceType: content.insurance_type,
                            isFullWidth: false,
                            phoneNumber: InsurancePricingConstants/* PHONE_NUMBERS.REASON */.u.REASON
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper.GlobalFaq, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq/* default */.Z, {
                            className: "ph0-f ph0-md-f pt0-sm",
                            faq: generalFaqs,
                            supportClickEventData: {
                                extraData: {
                                    apptReasonId: content.id
                                }
                            },
                            skipLinkTargetId: "footer"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedLinks, {
                condition: content.name,
                relatedTo: content.related_to
            })
        ]
    }, JSON.stringify(isSm));
};
const getInitialProps = async (param)=>{
    let { reasonContent , reason , req , store , query , pathname  } = param;
    const { isMobile  } = store.getState().config;
    const slug = query.slug;
    const [apptReasonLocationIds] = await Promise.all([
        (0,fetchLocationsByReasonId/* fetchLocationsByReasonId */.I)(reason.id),
        (0,featureFlags/* fetchFeatureFlags */.Vw)({
            [featureFlagConstants/* FeatureFlag.GROWTH_DISCOVERY_APPT_REASON_PAGE_AVAILABILITY_ENABLED */.T.GROWTH_DISCOVERY_APPT_REASON_PAGE_AVAILABILITY_ENABLED]: true,
            [featureFlagConstants/* FeatureFlag.GROWTH_HRSA_FAQ_CHANGES_ENABLED */.T.GROWTH_HRSA_FAQ_CHANGES_ENABLED]: true
        }, {
            dispatch: store.dispatch,
            overrideAttribute: {
                isMobileBrowser: JSON.stringify(isMobile),
                slug,
                pathname
            },
            req,
            query
        })
    ]);
    return {
        apptReasonLocationIds,
        content: reasonContent,
        reason
    };
};

// EXTERNAL MODULE: ./src/components/v5/Reason/CareDiscoverySearch/CareDiscoverySearch.tsx + 16 modules
var CareDiscoverySearch = __webpack_require__(57852);
// EXTERNAL MODULE: ./src/_services/monolith/appointmentReasons.ts
var appointmentReasons = __webpack_require__(82858);
// EXTERNAL MODULE: ./src/components/v5/Reason/CareDiscoverySearch/careDiscoveryAnalytics.ts
var careDiscoveryAnalytics = __webpack_require__(9121);
// EXTERNAL MODULE: ./src/utils/fetchPricingData.ts
var fetchPricingData = __webpack_require__(37059);
;// CONCATENATED MODULE: ./src/page-containers/get-care/topic.tsx























const Topic = (param)=>{
    let { content  } = param;
    var _content_meta, _content_meta1, _content_faqs;
    const i18n = (0,src_i18n/* useTranslation */.$G)();
    const { host  } = (0,src_store/* useTypedSelector */.ix)((state)=>state.config);
    const isDetectTopicPage = content.slug === "covid-care-for-detect-patients";
    const [detectHeaderImages, setDetectHeaderImages] = (0,react.useState)(undefined);
    const detectHeaderImageList = (0,react.useMemo)(()=>[
            {
                src: "/partners/detect/detect-hub",
                alt: i18n.t("Parts of Detect Hub")
            },
            {
                src: "/partners/detect/starter-kit",
                alt: i18n.t("Boxes of Detect Hub")
            },
            {
                src: "/partners/detect/starter-kit-try",
                alt: i18n.t("The patient takes the swab using the kit")
            }
        ], [
        i18n
    ]);
    // there is an issue that Sticky doesnt get sized correctly if ImageCarousel is loaded upfront. Until the issue is fixed,
    // we delay rendering of the ImageCarousel here.
    (0,react.useEffect)(()=>{
        if (isDetectTopicPage) {
            // @ts-expect-error TS2345: Argument of type '{ src: string; alt: string; }[]' is not assignable to parameter of type 'SetStateAction<undefined>'.
            const timer = setTimeout(()=>setDetectHeaderImages(detectHeaderImageList), 500);
            return ()=>clearTimeout(timer);
        }
    }, [
        i18n
    ]);
    const { backgroundColor , patternSrc  } = (0,getCareDiscoveryColorScheme/* getCareDiscoveryColorScheme */.m)(content.id, content.name);
    const isSm = (0,useMediaQuery/* default */.Z)("sm");
    const generalFaqs = (0,react.useMemo)(()=>{
        var _content_shared_faqs;
        return ((_content_shared_faqs = content.shared_faqs) === null || _content_shared_faqs === void 0 ? void 0 : _content_shared_faqs.reduce((acc, next)=>next.faqs ? [
                ...acc,
                ...next.faqs.map((qa)=>({
                        q: qa.question,
                        a: qa.answer
                    }))
            ] : acc, [])) || [];
    }, [
        content.shared_faqs
    ]);
    const ogImagePath = getOgImagePath("/get-care/[slug]", {
        id: content.id,
        title: content.name
    }, host);
    const pageTitle = ((_content_meta = content.meta) === null || _content_meta === void 0 ? void 0 : _content_meta.title) || "".concat((0,titleCase/* toTitleCase */.L)(content.name), " | Carbon Health");
    const defaultResults = (0,react.useMemo)(()=>[
            ...content.cares || [],
            ...content.related_topics || []
        ], [
        content.id
    ]);
    const viewId = (0,careDiscoveryAnalytics/* useSendDefaultResultsViewedEvent */.Vt)({
        results: defaultResults,
        isLoading: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        pageTitle: pageTitle,
        pageDescription: ((_content_meta1 = content.meta) === null || _content_meta1 === void 0 ? void 0 : _content_meta1.description) || content.description,
        navTheme: isSm ? useNavState/* NavTheme.BLACK */.Xm.BLACK : useNavState/* NavTheme.DEFAULT */.Xm.DEFAULT,
        navStartTransparent: isSm,
        absolutePageImage: ogImagePath,
        wrapClasses: "ovf-unset" // required for position sticky to work
        ,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper.Grid, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper.Faq, {
                        backgroundColor: backgroundColor,
                        patternSrc: patternSrc,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reason_ApptReasonFaq, {
                            title: content.name,
                            description: content.description,
                            faq: ((_content_faqs = content.faqs) === null || _content_faqs === void 0 ? void 0 : _content_faqs.map((qa)=>({
                                    q: qa.question,
                                    a: qa.answer
                                }))) || [],
                            isInsuranceAccepted: content.insurance_type !== types/* CareInsuranceType.NoInsurance */.o.NoInsurance
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper.Action, {
                        isSticky: !isSm,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareDiscoverySearch/* default */.Z, {
                            defaultResults: defaultResults,
                            dialogTitle: i18n.t("What brings you in?"),
                            isSearchEnabled: content.insurance_type !== types/* CareInsuranceType.OccupationalHealth */.o.OccupationalHealth,
                            headerImages: isDetectTopicPage ? detectHeaderImages : undefined,
                            hideHeadline: isSm,
                            viewId: viewId
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper.Insurances, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Insurances/* default */.ZP, {
                            headerText: (0,Insurances/* getCareInsuranceText */.E6)(i18n.t.bind(i18n), content.insurance_type, content.name),
                            insuranceType: content.insurance_type,
                            isFullWidth: false,
                            phoneNumber: InsurancePricingConstants/* PHONE_NUMBERS.REASON */.u.REASON
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper.GlobalFaq, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Faq/* default */.Z, {
                            className: "ph0-f ph0-md-f pt0-sm",
                            faq: generalFaqs,
                            supportClickEventData: {
                                extraData: {
                                    apptReasonId: content.id
                                }
                            },
                            skipLinkTargetId: "footer"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RelatedLinks, {
                condition: content.name,
                relatedTo: content.related_topics
            })
        ]
    }, JSON.stringify(isSm));
};
const topic_getInitialProps = async (param)=>{
    let { content , store , req  } = param;
    const defaultFlags = {
        CARE_DISCOVERY_TOPICS_SEARCH_ENABLED: true,
        GROWTH_HRSA_FAQ_CHANGES_ENABLED: true,
        GROWTH_DISCOVERY_SEARCH_AVAILABILITY_ENABLED: true
    };
    await (0,featureFlags/* fetchFeatureFlags */.Vw)(defaultFlags, {
        overrideAttribute: {
            slug: content.slug
        },
        dispatch: store.dispatch,
        anonymous: false,
        req
    });
    const prices = await (0,fetchPricingData/* fetchPricingData */.H)();
    store.dispatch(src_store/* actions.setRegionPricing */.Nw.setRegionPricing(prices));
    if (!store.getState().config.reasons) {
        const reasons = (await (0,appointmentReasons/* loadAppointmentReasons */.J)(practiceIds/* PracticeId.CARBON */.I.CARBON) || []).mapPick([
            "id",
            "slug",
            "name",
            "iconName",
            "description",
            "specialtyIds",
            "newPatientDuration",
            "supportsVideoVisit",
            "supportsInstantVisit",
            "practiceApptReasonSpecialties"
        ]).filter((r)=>r.practiceApptReasonSpecialties.some((reasonSpecialty)=>reasonSpecialty.sortIndex));
        store.dispatch(src_store/* actions.setConfig */.Nw.setConfig({
            reasons
        }));
    }
    return {
        content
    };
};

;// CONCATENATED MODULE: ./src/page-containers/get-care/[slug].tsx










const rednamedCareSlugs = {
    "allergy-symptoms-allergy-treatment": "allergy-symptoms",
    flu: "flu-shot",
    follow_up_pcp: "follow-up-pcp",
    "medication-refill": "medication-prescription-refill",
    mental_health_follow_up: "mental-health-follow-up",
    "pink-eye": "red-eye-pink-eye",
    "prescription-refill": "medication-prescription-refill",
    "routine-physical": "routine-physical-exam",
    "rx-refill": "medication-prescription-refill",
    rx: "medication-prescription-refill",
    "sinus-infection-symptoms": "sinus-infection",
    "sports-physical": "sports-physical-exam",
    "std-test": "sti-test",
    "urinary-tract-infection-uti-symptoms": "urinary-tract-infection",
    womens_health: "womens-health",
    "yeast-infection-symptoms": "yeast-infection"
};
const isTopicProps = (props)=>{
    var _props_content;
    return Boolean((_props_content = props.content) === null || _props_content === void 0 ? void 0 : _props_content.cares);
};
const CareItem = (props)=>isTopicProps(props) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Topic, {
        ...props
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Reason, {
        ...props
    });
CareItem.getInitialProps = async (context)=>{
    const { res , query , req , asPath  } = context;
    if (asPath && !!req && res) (0,redirectToLowercase/* redirectToLowercase */.O)(asPath, res);
    const slug = query.slug;
    const type = query.type;
    const maybeNewSlug = rednamedCareSlugs[slug];
    const careEntry = await (0,cms/* fetchCareEntry */.WP)(slug);
    if ((careEntry === null || careEntry === void 0 ? void 0 : careEntry.type) === cms/* CareType.TOPIC */.BW.TOPIC) {
        return topic_getInitialProps({
            content: careEntry.content,
            ...context
        });
    }
    const reason = await (0,api/* fetchReasonBySlug */.f_)(maybeNewSlug || slug, practiceIds/* PracticeId.CARBON */.I.CARBON);
    if (res) {
        if (!reason) {
            res.writeHead(302, {
                Location: _constants/* v5Pages.getCareRoot */.Td.getCareRoot
            });
            res.end();
            return {};
        }
        if (maybeNewSlug) {
            res.writeHead(301, {
                Location: "".concat(_constants/* v5Pages.getCareRoot */.Td.getCareRoot, "/").concat(maybeNewSlug)
            });
            res.end();
            return {};
        }
        if (!careEntry || !careEntry.content && !(0,isReasonDiscoverable/* isReasonDiscoverable */.t)(reason)) {
            res.writeHead(302, {
                Location: _constants/* v5Pages.getCareRoot */.Td.getCareRoot
            });
            res.end();
            return {};
        }
        if (reason && type && type !== "get-care") {
            res.writeHead(301, {
                Location: "".concat(_constants/* v5Pages.getCareRoot */.Td.getCareRoot, "/").concat(slug)
            });
            res.end();
            return {};
        }
    }
    if (reason && (careEntry === null || careEntry === void 0 ? void 0 : careEntry.content)) {
        return getInitialProps({
            reason,
            reasonContent: careEntry.content,
            ...context
        });
    }
    return {};
};
/* harmony default export */ var _slug_ = (CareItem);

;// CONCATENATED MODULE: ./src/pages/get-care/[slug].ts

/* harmony default export */ var get_care_slug_ = (_slug_);


/***/ }),

/***/ 97142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ fetchLocationsByReasonId; },
/* harmony export */   "m": function() { return /* binding */ fetchPaginatedLocationIdsForApptReason; }
/* harmony export */ });
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3607);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95832);


const fetchPaginatedLocationIdsForApptReason = (param)=>{
    let { reasonId , latitude , longitude , page , pageSize , distance  } = param;
    return _services_api__WEBPACK_IMPORTED_MODULE_0__/* .api.post */ .hi.post("/hib/reasons/".concat(reasonId, "/locations"), {
        latitude,
        longitude,
        page,
        pageSize,
        distance
    }).then((res)=>res.json()).catch((err)=>{
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(err);
        return [];
    });
};
/**
 * This API returns a max of 50 locations per request
 * Because we need to filter regions by availability,
 * we need to here find all locations which can service an apptReason,
 * not just the locations in selectedRegion and later filter by region
 * after slots/availability is known.
 *
 * Page number is set to 5 because it seems that most reasons will return
 * around 150 locations. 5 will give a safe buffer to account for additional locations.
 *
 * This can moved to the frontend to run on a specific coordinate with
 * every selectedRegion change after we have a null state to show that
 * there are no locations in the selectedRegion.
 */ const fetchLocationsByReasonId = function(reasonId) {
    let pageCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5;
    return Promise.all(Array(pageCount).fill(null).map((x, i)=>fetchPaginatedLocationIdsForApptReason({
            reasonId,
            // Center of contiguous US
            latitude: 39,
            longitude: -98,
            distance: 3000,
            page: i + 1
        }))).then((pages)=>pages.flat()).catch((err)=>{
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(err);
        return [];
    });
};


/***/ }),

/***/ 56040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ redirectToLowercase; }
/* harmony export */ });
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3607);

const redirectToLowercase = (asPath, res)=>{
    try {
        const [path, query] = asPath.split("?");
        if (path !== path.toLowerCase()) {
            const location = query ? "".concat(path.toLowerCase(), "?").concat(query) : path.toLowerCase();
            res.writeHead(308, {
                Location: location
            });
            res.end();
        }
    } catch (e) {
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb(e);
    }
};


/***/ }),

/***/ 32940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ toTitleCase; }
/* harmony export */ });
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58371);
/* harmony import */ var lodash_startCase__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_startCase__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_toLower__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59491);
/* harmony import */ var lodash_toLower__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_toLower__WEBPACK_IMPORTED_MODULE_1__);


const toTitleCase = (sentence)=>{
    if (!sentence) return "";
    return lodash_startCase__WEBPACK_IMPORTED_MODULE_0___default()(lodash_toLower__WEBPACK_IMPORTED_MODULE_1___default()(sentence));
};


/***/ }),

/***/ 4080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__apSBd"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2745,3014,2493,6282,2122,620,7852,2320,9774,2888,179], function() { return __webpack_exec__(89272); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);